<template>
  <div>
    <v-dialog v-model="exibir" scrollable persistent :max-width="maxWidth">
      <v-card>
        <v-card-title class="primary modal-title py-0">
          <span>Documentos do fornecedor</span>
          <v-spacer/>
          <v-btn icon aria-label="Fechar" @click="fecharModal">
            <v-icon size="20" color="white">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="documentos-vencedor">
          <v-select v-if="possuiFornecedores"
                    v-model="fornecedorId"
                    :items="opcoesFornecedores"
                    :disabled="carregando"
                    :menu-props="{ top: false, offsetY: true }"
                    label="Fornecedor"
                    hide-details
                    class="documentos-vencedor__fornecedor"
                    @change="buscarDocumentos"/>
          <div v-if="carregando" class="text-xs-center py-4">
            <v-progress-circular indeterminate color="primary"/>
          </div>
          <div v-else-if="mensagemErro" class="documentos-vencedor__erro">{{ mensagemErro }}</div>
          <div v-else-if="possuiFornecedores">
            <span v-if="!recaptchaDownloadPubAtivo" id="documentos-vencedor-nova-aba" class="documentos-vencedor__oculto">(abre em nova aba)</span>

            <fieldset class="documentos-vencedor__grupo">
              <legend>Documentos de Proposta</legend>
              <ul>
                <li>
                  <a v-bind="atributosLink(urlProposta)"
                     class="documentos-vencedor__link"
                     @click="solicitarDownload($event, documentoVencedor('proposta'))">Visualizar Proposta</a>
                </li>
                <li v-if="documentos.possuiTermoCredenciamento">
                  <a v-bind="atributosLink(urlTermoCredenciamento)"
                     class="documentos-vencedor__link"
                     @click="solicitarDownload($event, documentoVencedor('termo-credenciamento'))">Termo de Credenciamento</a>
                </li>
                <li v-if="exibirTermoHabilitacao">
                  <a v-bind="atributosLink(urlTermoHabilitacao)"
                     class="documentos-vencedor__link"
                     @click="solicitarDownload($event, documentoVencedor('termo-habilitacao'))">Termo de Habilitação</a>
                </li>
              </ul>
              <template v-if="anexosProposta.length">
                <span class="documentos-vencedor__subtitulo">Anexos:</span>
                <ul>
                  <li v-for="documento in anexosProposta" :key="`proposta-${documento.id}`">
                    <a v-bind="atributosLink(urlArquivo(documento.uri))"
                       class="documentos-vencedor__link"
                       @click="solicitarDownload($event, documentoAnexo(documento.uri, documento.descricao))">{{ documento.descricao }}</a>
                  </li>
                </ul>
              </template>
            </fieldset>

            <fieldset v-if="documentos.exibirDocumentosHabilitacao" class="documentos-vencedor__grupo">
              <legend>Documentos</legend>
              <span v-if="documentos.documentosHabilitacao.length" class="documentos-vencedor__subtitulo">Anexos:</span>
              <ul>
                <li v-for="documento in documentos.documentosHabilitacao" :key="`habilitacao-${documento.id}`">
                  <a v-bind="atributosLink(urlArquivo(documento.uri))"
                     class="documentos-vencedor__link"
                     @click="solicitarDownload($event, documentoAnexo(documento.uri, documento.descricao))">{{ documento.descricao }}</a>
                </li>
              </ul>
            </fieldset>

            <fieldset v-if="possuiDocumentosSolicitados" class="documentos-vencedor__grupo">
              <legend>Documentos Solicitados ao Fornecedor</legend>
              <ul>
                <li v-for="documento in documentos.documentosSolicitados" :key="`solicitado-${documento.id}`">
                  <a v-bind="atributosLink(urlArquivo(documento.uri))"
                     class="documentos-vencedor__link"
                     @click="solicitarDownload($event, documentoAnexo(documento.uri, documento.descricao))">{{ documento.descricao }}</a>
                  <b v-if="documento.dataCriacao"> - Anexado em: {{ documento.dataCriacao | az-date('DD/MM/YYYY HH:mm:ss') }}</b>
                </li>
              </ul>
            </fieldset>

            <fieldset v-if="possuiFichasCatalogos" class="documentos-vencedor__grupo">
              <legend>Ficha/Catálogo</legend>
              <ul>
                <template v-for="(fichaCatalogo, index) in documentos.fichasCatalogos">
                  <li v-if="fichaCatalogo.catalogoUri" :key="`catalogo-${index}`">
                    <a v-bind="atributosLink(urlArquivo(fichaCatalogo.catalogoUri))"
                       class="documentos-vencedor__link"
                       @click="solicitarDownload($event, documentoAnexo(fichaCatalogo.catalogoUri))">Catálogo - {{ fichaCatalogo.descricaoItem }}</a>
                  </li>
                  <li v-if="fichaCatalogo.fichaTecnicaUri" :key="`ficha-${index}`">
                    <a v-bind="atributosLink(urlArquivo(fichaCatalogo.fichaTecnicaUri))"
                       class="documentos-vencedor__link"
                       @click="solicitarDownload($event, documentoAnexo(fichaCatalogo.fichaTecnicaUri))">Ficha Técnica - {{ fichaCatalogo.descricaoItem }}</a>
                  </li>
                </template>
              </ul>
            </fieldset>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import {actionTypes} from '@/core/constants'
import FileManagerUtils from '@/core/utils/FileManagerUtils'

const MENSAGEM_ERRO_PADRAO = 'Não foi possível carregar os documentos do fornecedor selecionado.'
const MENSAGEM_ERRO_FORNECEDORES = 'Não foi possível carregar os fornecedores do lote.'
const MENSAGEM_ERRO_DOWNLOAD = 'Não foi possível baixar o documento do fornecedor.'
const ACAO_BAIXAR_DOCUMENTO_FORNECEDOR = 'BAIXAR_DOCUMENTO_FORNECEDOR'

const NOMES_ARQUIVOS_VENCEDOR = {
    'proposta': 'PropostaPregao.pdf',
    'termo-credenciamento': 'TermoCredenciamento.pdf',
    'termo-habilitacao': 'TermoHabilitacao.pdf'
}

const DESCRICOES_SITUACAO = {
    VENCEDOR: 'Vencedor',
    DESCLASSIFICADO: 'Desclassificado',
    INABILITADO: 'Inabilitado'
}

const documentosVazios = () => ({
    razaoSocialFornecedor: '',
    documentosProposta: [],
    documentosReadequacao: [],
    possuiTermoCredenciamento: false,
    possuiTermoHabilitacao: false,
    exibirDocumentosHabilitacao: false,
    documentosHabilitacao: [],
    documentosSolicitados: [],
    fichasCatalogos: []
})

export default {
    name: 'ModalDocumentosFornecedorVencedor',
    props: {
        maxWidth: {
            type: String,
            default: '700'
        },
    },
    data() {
        return {
            exibir: false,
            carregando: false,
            mensagemErro: '',
            licitacaoId: null,
            loteId: null,
            fornecedores: [],
            fornecedorId: null,
            requisicaoDocumentos: 0,
            documentos: documentosVazios()
        }
    },
    computed: {
        recaptchaDownloadPubAtivo() {
            const parametros = this.$store.state.parametros
            return !!parametros && parametros.recaptchaDownloadPubAtivo === true
        },
        urlBaseVencedor() {
            return `/licitacao/api/public/v1/licitacoes/${this.licitacaoId}/lotes/${this.loteId}/vencedor`
        },
        parametroFornecedor() {
            return `?fornecedorId=${this.fornecedorId}`
        },
        urlProposta() {
            return `${this.urlBaseVencedor}/proposta${this.parametroFornecedor}`
        },
        urlTermoCredenciamento() {
            return `${this.urlBaseVencedor}/termo-credenciamento${this.parametroFornecedor}`
        },
        urlTermoHabilitacao() {
            return `${this.urlBaseVencedor}/termo-habilitacao${this.parametroFornecedor}`
        },
        possuiFornecedores() {
            return this.fornecedores.length > 0
        },
        opcoesFornecedores() {
            return this.fornecedores.map(fornecedor => ({
                value: fornecedor.fornecedorId,
                text: `${fornecedor.razaoSocial} (${DESCRICOES_SITUACAO[fornecedor.situacao] || fornecedor.situacao})`
            }))
        },
        exibirTermoHabilitacao() {
            return this.documentos.exibirDocumentosHabilitacao && this.documentos.possuiTermoHabilitacao
        },
        anexosProposta() {
            return [...this.documentos.documentosProposta, ...this.documentos.documentosReadequacao]
        },
        possuiDocumentosSolicitados() {
            return this.documentos.documentosSolicitados.length > 0
        },
        possuiFichasCatalogos() {
            return this.documentos.fichasCatalogos.length > 0
        }
    },
    methods: {
        async open({licitacaoId, loteId} = {}) {
            this.licitacaoId = licitacaoId
            this.loteId = loteId
            this.limpar()
            this.exibir = true
            await this.buscarFornecedores()
            if (this.fornecedorId) {
                await this.buscarDocumentos()
            }
        },
        async buscarFornecedores() {
            this.carregando = true
            try {
                const resultado = await this.$store.dispatch(actionTypes.BUSCAR_FORNECEDORES_LOTE, {
                    licitacaoId: this.licitacaoId,
                    loteId: this.loteId
                })
                this.fornecedores = (resultado && resultado.fornecedores) || []
                const vencedor = this.fornecedores.find(fornecedor => fornecedor.situacao === 'VENCEDOR') || this.fornecedores[0]
                this.fornecedorId = vencedor ? vencedor.fornecedorId : null
                if (!vencedor) {
                    this.mensagemErro = MENSAGEM_ERRO_FORNECEDORES
                }
            } catch (erro) {
                this.mensagemErro = this.extrairMensagemErro(erro, MENSAGEM_ERRO_FORNECEDORES)
            } finally {
                this.carregando = false
            }
        },
        async buscarDocumentos() {
            const requisicao = ++this.requisicaoDocumentos
            this.carregando = true
            this.mensagemErro = ''
            this.documentos = documentosVazios()
            try {
                const resultado = await this.$store.dispatch(actionTypes.BUSCAR_DOCUMENTOS_VENCEDOR_LOTE, {
                    licitacaoId: this.licitacaoId,
                    loteId: this.loteId,
                    fornecedorId: this.fornecedorId
                })
                if (requisicao === this.requisicaoDocumentos) {
                    this.documentos = {...documentosVazios(), ...resultado}
                }
            } catch (erro) {
                if (requisicao === this.requisicaoDocumentos) {
                    this.mensagemErro = this.extrairMensagemErro(erro, MENSAGEM_ERRO_PADRAO)
                }
            } finally {
                if (requisicao === this.requisicaoDocumentos) {
                    this.carregando = false
                }
            }
        },
        extrairMensagemErro(erro, mensagemPadrao) {
            return (erro && erro.response && erro.response.data && erro.response.data.message) || mensagemPadrao
        },
        urlArquivo(uri) {
            return FileManagerUtils.createUrl(uri)
        },
        atributosLink(url) {
            if (this.recaptchaDownloadPubAtivo) {
                return {href: '#', role: 'button'}
            }
            return {href: url, target: '_blank', 'aria-describedby': 'documentos-vencedor-nova-aba'}
        },
        documentoVencedor(tipoDocumento) {
            return {tipoDocumento, nomeArquivo: NOMES_ARQUIVOS_VENCEDOR[tipoDocumento]}
        },
        documentoAnexo(uri, descricao) {
            return {uri, nomeArquivo: descricao || uri.split('/').pop()}
        },
        solicitarDownload(evento, documento) {
            if (!this.recaptchaDownloadPubAtivo) {
                return
            }
            evento.preventDefault()
            this.$emit('solicitarCaptchaDownload', {acao: ACAO_BAIXAR_DOCUMENTO_FORNECEDOR, documento})
        },
        async baixarDocumento(documento, captchaResponse) {
            const headers = {'az-licitacao-captcha': captchaResponse}
            try {
                if (documento.tipoDocumento) {
                    await this.$store.dispatch(actionTypes.BAIXAR_DOCUMENTO_VENCEDOR_LOTE, {
                        licitacaoId: this.licitacaoId,
                        loteId: this.loteId,
                        tipoDocumento: documento.tipoDocumento,
                        fornecedorId: this.fornecedorId,
                        nomeArquivo: documento.nomeArquivo,
                        headers
                    })
                } else {
                    const payload = {
                        licitacaoId: this.licitacaoId,
                        nomeArquivo: documento.nomeArquivo,
                        uri: documento.uri,
                        areaPublica: true
                    }
                    await this.$store.dispatch(actionTypes.FLOWBEE.BAIXAR_ARQUIVO, {payload, headers})
                }
            } catch (erro) {
                this.mostrarNotificacaoErro(MENSAGEM_ERRO_DOWNLOAD)
            }
        },
        limpar() {
            this.fornecedores = []
            this.fornecedorId = null
            this.documentos = documentosVazios()
            this.mensagemErro = ''
        },
        fecharModal() {
            this.exibir = false
            this.limpar()
        }
    }
}
</script>
<style lang="stylus">
.documentos-vencedor
  ul
    list-style none
    padding-left 0
    margin-bottom 8px
  li
    padding 2px 0
.documentos-vencedor__fornecedor
  margin-bottom 16px
  padding-top 8px
.documentos-vencedor__grupo
  border 1px solid #dddddd
  border-radius 3px
  margin-bottom 12px
  padding 4px 12px 8px
  legend
    color #0067b1
    font-weight 600
    padding 0 4px
.documentos-vencedor__subtitulo
  color #666666
  display block
  font-weight bold
  margin-top 8px
.documentos-vencedor__link
  color #1976d2 !important
  cursor pointer
  text-decoration underline !important
  &:hover
    color #0d47a1 !important
  &:visited
    color #6a1b9a !important
.documentos-vencedor__erro
  color #757575
  padding 16px 0
.documentos-vencedor__oculto
  border 0
  clip rect(0 0 0 0)
  height 1px
  margin -1px
  overflow hidden
  padding 0
  position absolute
  white-space nowrap
  width 1px
</style>
